/**
 * free-gift-cart.js
 * Keeps free-gift cart lines in sync with their paired main product.
 *
 * Relies on properties set at /cart/add.js time:
 *   properties._free_gift      = "true"
 *   properties._free_gift_for  = "<main product variant id>"
 *
 * Whenever the cart changes (via Dawn's cart-items / cart-drawer-items,
 * which publish PUB_SUB_EVENTS.cartUpdate with the fresh cart JSON), this
 * checks whether each gift line's paired main variant is still in the
 * cart. If not, it removes the gift line via /cart/change.js (targeted
 * by line item key, not position, so it's safe regardless of how the
 * cart was mutated) and republishes cartUpdate so Dawn's own cart-items
 * / cart-drawer-items elements re-render themselves - no page reload.
 */
(function () {
  var SOURCE = 'free-gift-cart';

  function reconcile(items) {
    if (!items || !items.length) return;

    var presentVariantIds = items.map(function (i) {
      return String(i.variant_id);
    });

    var orphanKeys = items
      .filter(function (i) {
        return (
          i.properties &&
          i.properties._free_gift === 'true' &&
          i.properties._free_gift_for &&
          presentVariantIds.indexOf(String(i.properties._free_gift_for)) === -1
        );
      })
      .map(function (i) {
        return i.key;
      });

    if (!orphanKeys.length) return;

    Promise.all(
      orphanKeys.map(function (key) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        }).then(function (response) {
          return response.json();
        });
      })
    )
      .then(function (results) {
        var latestCart = results[results.length - 1];
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: SOURCE, cartData: latestCart });
        }
      })
      .catch(function (error) {
        console.error('free-gift-cart: failed to remove orphaned gift line', error);
      });
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      // pubsub.js / constants.js not loaded yet or missing - nothing we can do.
      return;
    }

    // React to every future cart change (add/update/remove from any
    // cart-items or cart-drawer-items instance on the page).
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event.source === SOURCE) return; // avoid reacting to our own update
      if (!event.cartData || !event.cartData.items) return;
      reconcile(event.cartData.items);
    });

    // Also check once on page load, in case a gift was orphaned before
    // this script existed, or the cart was modified outside the UI.
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        reconcile(cart.items);
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();